import './header.css'
import logo from "../../assets/img/logo.svg";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Link } from "react-router-dom";
import { useState } from "react";
const Header = () => {
	const [isOnOne, setIsOnOne] = useState(false);
	const [isOnTwo, setIsOnTwo] = useState(false);
	const [isOnMobile, setIsOnMobile] = useState(false);
	const [isHeaderOn, setIsHeaderOn] = useState(false);

	const dropdownClickOne = () => {
		setIsOnOne(!isOnOne);
		setIsOnTwo(false);
	};
	const dropdownClickTwo = () => {
		setIsOnTwo(!isOnTwo);
		setIsOnOne(false);
	};
	window.onscroll = () => {
		setIsOnMobile(false);
		if (window.scrollY > 96) {
			setIsHeaderOn(true);
		} else {
			setIsHeaderOn(false);
		}
	};

	return (
		<header className={`main-header ${isHeaderOn && "is-sticky"}`}>
			<div className="container">
				<Link to="/" className="logo-holder">
					<img src={logo} alt="main-logo" />
				</Link>
				<nav className={`nav-links t-3 ${isOnMobile && "on"}`}>
					<Link to="/" className="nav-item t-3">
						Home
					</Link>
					<Link to="/ueber-uns" className="nav-item t-3">
						Über uns
					</Link>
					<span
						to="/"
						className={`dropdown t-3 ${isOnOne && "on"}`}
						onClick={dropdownClickOne}
					>
						Leistungen
						<i className="t-3">
							<KeyboardArrowDownRoundedIcon />
						</i>
						<ul className="dropdown-menu t-3">
							<li className="nav-item">
								<Link
									to="/leistungen/pflegeberatung.html"
									className="nav-link t-3"
								>
									Pflegeberatung
								</Link>
							</li>
							<li className="nav-item">
								<Link
									to="/leistungen/mobile-pflege.html"
									className="nav-link t-3"
								>
									Mobile Pflege
								</Link>
							</li>
							<li className="nav-item">
								<Link
									to="/leistungen/tagespflege.html"
									className="nav-link t-3"
								>
									Tagespflege
								</Link>
							</li>
							<li className="nav-item">
								<Link to="/leistungen/wohngruppe.html" className="nav-link t-3">
									Wohngruppe
								</Link>
							</li>
						</ul>
					</span>
					<span
						to="/"
						className={`dropdown t-3 ${isOnTwo && "on"}`}
						onClick={dropdownClickTwo}
					>
						Karriere
						<i className="t-3">
							<KeyboardArrowDownRoundedIcon />
						</i>
						<ul className="dropdown-menu t-3">
							<li className="nav-item">
								<Link to="/karriere/jobs.html" className="nav-link t-3">
									Jobs
								</Link>
							</li>
							<li className="nav-item">
								<Link to="/karriere/ausbildung.html" className="nav-link t-3">
									Ausbildung
								</Link>
							</li>
						</ul>
					</span>
					<Link to="/" className="nav-item t-3">
						FAQ
					</Link>
				</nav>
				<Link to="/kontakt" className="main-btn t-3">
					kontakt aufnehmen
				</Link>
				<i
					className={`burger ${isOnMobile && "on"}`}
					onClick={() => setIsOnMobile(!isOnMobile)}
				>
					<MenuRoundedIcon />
					<CloseRoundedIcon />
				</i>
			</div>
		</header>
	);
};

export default Header;
